import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiMalattieDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoMalattie({ tenantId: currentTenant.Id, assistitoId: assistitoId });
          },
    
          byKey: (key) => {
            return api.getAssistitoMalattiaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                malattiaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoMalattia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoMalattiaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoMalattia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                malattiaId: key,
                assistitoMalattiaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoMalattia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                malattiaId: key 
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


